import {DownloadApp} from '@/i18n/model/zh/page-content/download-app'


export const PageContent = {
  downloadApp: DownloadApp,
}
